import React from 'react'
import { Form, Button, Input} from 'semantic-ui-react'
import { displayCurrency } from '../../../utils/utils'

export default class RetailPrice extends React.Component{
  state = { isEditing: false, value: this.props.retailPrice }

  onChange = (event) => {
    this.setState({ value: event.target.value.replace(/[^\d\.]/gi, "") })
  }

  onSave = () => {
    this.props.onSave(this.state.value)
    this.setState({ isEditing: false })
  }

  render() {
    const { isEditing, value } = this.state

    return (
      <React.Fragment>
        <Form style={{ alignSelf: "flex-start", whiteSpace: "pre-wrap" }}>
          {isEditing ? <Input value={value} onChange={this.onChange} /> : displayCurrency(value)}
        </Form>

        {!isEditing &&
          <Button
            style={{ marginTop: "10px" }}
            size="mini"
            color="orange" s
            onClick={() => this.setState({ isEditing: true })}
          >
            Edit
          </Button>
        }
        {isEditing &&
          <React.Fragment>
            <Button
              style={{ marginTop: "10px" }}
              size="mini" color="orange" s
              onClick={this.onSave}
            >
              Done
            </Button>
            <Button
              style={{ marginTop: "10px" }}
              size="mini" color="grey"
              onClick={() => this.setState({ isEditing: false, value: this.props.retailPrice })}
            >
              Cancel
            </Button>
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
}
